module.exports = __webpack_public_path__ + "img/mintme.539c9bc9.svg";